export default "__VITE_ASSET__CWHJbst___"